export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";